"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var FinanceRevsharesListCtl = /** @class */ (function (_super) {
    __extends(FinanceRevsharesListCtl, _super);
    function FinanceRevsharesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_partner_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_id; });
        _this.dk_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_login; });
        _this.dk_pprogram_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_id; });
        _this.dk_pprogram_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.pprogram_title; });
        _this.dk_brand_offer_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_offer_id; });
        _this.dk_brand_offer_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_offer_title; });
        _this.dk_partner_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_currency_id; });
        _this.dk_partner_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_currency_title; });
        _this.dk_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount; });
        _this.dk_revshare_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.revshare_type_code; });
        _this.dk_revshare_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.revshare_type_title; });
        _this.dk_flow_state_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.flow_state_code; });
        _this.dk_flow_state_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.flow_state_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_pending = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_pending; });
        _this.dk_admin_cashier_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.admin_cashier_id; });
        _this.dk_admin_cashier_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.admin_cashier_login; });
        _this.dk_balance_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.balance_before; });
        _this.dk_balance_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.balance_after; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    FinanceRevsharesListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    FinanceRevsharesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    FinanceRevsharesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPProgramPartnerRevshare.exec({
            data: {
                usr_partner_id: data.usr_partner_id,
                brand_offer_id: data.brand_offer_id,
                amount: data.amount,
                description: data.description,
                revshare_type_code: data.revshare_type_code
                // total_bet_amount: data.total_bet_amount,
                // is_not_withdraw_amount_from_next_balance: data.is_not_withdraw_amount_from_next_balance
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                brand_id: resp.brand_id,
                brand_title: resp.brand_title,
                pprogram_id: resp.pprogram_id,
                pprogram_title: resp.pprogram_title,
                brand_offer_id: data.brand_offer_id,
                brand_offer_title: resp.brand_offer_title,
                partner_currency_id: resp.partner_currency_id,
                partner_currency_title: resp.partner_currency_title,
                amount: data.amount,
                revshare_type_code: data.revshare_type_code,
                revshare_type_title: resp.revshare_type_title,
                flow_state_code: resp.flow_state_code,
                flow_state_title: resp.flow_state_title,
                description: data.description,
                admin_cashier_id: resp.admin_cashier_id,
                admin_cashier_login: resp.admin_cashier_login,
                balance_before: resp.balance_before,
                balance_after: resp.balance_after,
                is_pending: true,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                date_changed: moment(resp.date_added_uts_ms).utc(false),
                partner_id: data.usr_partner_id,
                partner_login: resp.partner_login,
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceRevsharesListCtl.prototype.LoadRangeDataByBrandsList = function (data, onDone) {
        var _this = this;
        webAApi_1.ListPProgramPartnersRevsharesByDateRangeGet.exec({
            all_pprograms: data.allPPrograms,
            pprogram_id_list: data.pprograms,
            offset: data.Offset,
            limit: data.Limit,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    pprogram_id: resp.list[i].pprogram_id,
                    pprogram_title: resp.list[i].pprogram_title,
                    brand_offer_id: resp.list[i].brand_offer_id,
                    brand_offer_title: resp.list[i].brand_offer_title,
                    partner_currency_id: resp.list[i].partner_currency_id,
                    partner_currency_title: resp.list[i].partner_currency_title,
                    amount: resp.list[i].amount,
                    revshare_type_code: resp.list[i].revshare_type_code,
                    revshare_type_title: resp.list[i].revshare_type_title,
                    flow_state_code: resp.list[i].flow_state_code,
                    flow_state_title: resp.list[i].flow_state_title,
                    description: resp.list[i].description,
                    is_pending: resp.list[i].is_pending,
                    admin_cashier_id: resp.list[i].admin_cashier_id,
                    admin_cashier_login: resp.list[i].admin_cashier_login,
                    balance_before: resp.list[i].balance_before,
                    balance_after: resp.list[i].balance_after,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    partner_id: resp.list[i].partner_id,
                    partner_login: resp.list[i].partner_login,
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceRevsharesListCtl.prototype.DoGenerateRevshare = function (data, onDone) {
        var _this = this;
        webAApi_1.DoGeneratePProgramPartnersRevshares.exec({
            all_pprograms: data.allPPrograms,
            pprogram_id_list: data.pprograms,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            no_start_date: data.is_ignore_start_date
        }, function (resp) {
            //_tmp.flow_state_code = resp.moneyFlowStateCode;
            //  _tmp.flow_state_title = resp.moneyFlowStateTitle;
            _this.Update();
            if (onDone) {
                onDone(resp.generated_count);
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceRevsharesListCtl.prototype.DoConfirmRevshare = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoPProgramPartnerRevshareCommit.exec({
                data: {
                    usr_partner_money_flow_id: key
                }
            }, function (resp) {
                _tmp.flow_state_code = resp.moneyFlowStateCode;
                _tmp.flow_state_title = resp.moneyFlowStateTitle;
                _tmp.is_pending = false;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    FinanceRevsharesListCtl.prototype.DoRejectRevshare = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoPProgramPartnerRevshareReject.exec({
                data: {
                    usr_partner_money_flow_id: key
                }
            }, function (resp) {
                _tmp.flow_state_code = resp.moneyFlowStateCode;
                _tmp.flow_state_title = resp.moneyFlowStateTitle;
                _tmp.is_pending = false;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return FinanceRevsharesListCtl;
}(BaseController_1.BaseController));
exports.FinanceRevsharesListCtl = FinanceRevsharesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_revshares_list/ctl/FinanceRevsharesListCtl.ts
// module id = 1002
// module chunks = 0